module.exports = __webpack_public_path__ + "static/media/attempt1.9140527a.svg";